import {TransportLineItemEntity} from "@ots-frontend/ots-data";
import {Text} from "@mantine/core";
import {useMemo} from "react";
import {getFormattedDateTime} from "../../../date/FormattedDateTime/FormattedDateTime";
import {getFormattedQuantity} from "../../../text/FormattedQuantity/FormattedQuantity";
import {useTranslation} from "react-i18next";

export const TliDescriptionCell = (props: { tli: TransportLineItemEntity }) => {
  const {tli} = props

  const {t} = useTranslation(["common"])

  const description = useMemo(() => {
    let desc = ""

    if (tli.pickupCreateDttm) {
      desc += "Pickup Date: "
      desc += getFormattedDateTime(tli.pickupCreateDttm)
    }

    if (tli.deliveryCreateDttm) {
      if (desc.length > 0) {
        desc += ", "
      }
      desc += "Delivery Date: "
      desc += getFormattedDateTime(tli.deliveryCreateDttm)
    }

    if (tli.quantity) {
      if (desc.length > 0) {
        desc += ", "
      }
      desc += "Quantity: "
      desc += getFormattedQuantity(tli.quantity, tli.quantityUnitOfMeasure)
    }

    if (desc.length === 0) {
      desc += t("common.entity.transportlineitem.description.default", "No Description")
    }

    return desc
  }, [tli, t])

  return (
    <Text>
      {description}
    </Text>
  )
}
